import React from "react";
import { useSurvey } from "../../../../../common/hooks/api/useSurvey";
import { usePrimaryOrganizationId } from "../../../../hooks";
import { useHistory } from "react-router";
import { Routes } from "../../../../root/routes";
import { DEVELOPER_INSTRUCTIONS_SURVEY_NAME } from "../../PrivacyNoticeChecklistItems";
import { DevInstructionsFinishedHrDataMapSlug } from "../HRCenterDashboardPage";
import { EmployeePageWrapper } from "./EmployeePageWrapper";
import { DataStorageVendorSettingsTable } from "../../workflows/DataStorageSettingsPage";

export function EmployeeExceptionsPage() {
  const history = useHistory();

  const organizationId = usePrimaryOrganizationId();

  const { setAnswer: setDevSurveyAnswer } = useSurvey(
    organizationId,
    DEVELOPER_INSTRUCTIONS_SURVEY_NAME,
  );

  return (
    <EmployeePageWrapper
      selectedTabKey="employee-exceptions"
      nextContent="Done"
      nextOnClick={async () => {
        await setDevSurveyAnswer(DevInstructionsFinishedHrDataMapSlug, "true");
        history.push(Routes.hrCenter.root);
      }}
      nextDisabled={false}
      nextDisabledTooltip="Please make a selection for each Data Recipient before proceeding."
    >
      <div className="tw-boundary">
        <div className="mb-[40px] max-w-[800px]">
          <p>
            Your business will be required to delete personal data about employees and or applicants
            when they make a Request to Delete. However, not all data is subject to deletion. The
            CCPA allows businesses to retain a employee’s personal data for certain approved
            business purposes, known as “exceptions” to deletion.
          </p>
        </div>

        <DataStorageVendorSettingsTable
          orgId={organizationId}
          vendorsCollectionContexts={["EMPLOYEE"]}
        />
      </div>
    </EmployeePageWrapper>
  );
}
